module.exports = __webpack_public_path__ + "img/hot-sale.8610c790.png";